<template>
  <div>
    <spinner v-if="cargando" />
    <div v-else>
      <thumbnail-header
        class="clearfix"
        :imagen="datosEstadistica.alumno.foto_url"
        :titulo="fullname(datosEstadistica.alumno)"
        :subtitulo="subtitulo"
        tamano="md"
      />
      <div class="text-right">
        <div class="label label-default">
          {{ $I18n.t('Retrasos_totales') }}: {{ retrasosTotales }}
        </div>
      </div>
      <div>
        <canvas ref="chart" style="height: 200px;width: 100%"></canvas>
        <div class="chart-icons">
          <div
            v-for="tipo in tiposAsistencia"
            :key="tipo.label"
            class="icon-box"
          >
            <icono-asistencia :tipo="tipo.value" class="fa-16x chart-icon" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import usuarios from '@/api/usuarios';
import humanEnumName from '../../../libs/i18n';
import { underscore } from '../../../libs/strings';
import cuadernoAsistencias from '../../../api/cuadernos/asistencias';
import IconoAsistencia from '../../../components/cifra/iconos/IconoAsistencia.vue';

/* global Cifra, Chart */
export default {
  components: { IconoAsistencia },
  props: {
    admin: { type: Boolean, default: false },
    cuadernoId: { type: Number, required: true },
    alumnoId: { type: Number, required: true },
    fecha: { type: Date, required: true },
    tiposValidos: { type: Array, required: true },
  },
  data() {
    return {
      datosEstadistica: {},
      tiposAsistencia: [],
      retrasosTotales: 0,
      grupo: null,
    };
  },
  computed: {
    subtitulo() {
      if (!this.datosEstadistica.info_cuaderno) {
        return '';
      }
      let subtitulo = this.$I18n.t('registro_asistencia');
      if (this.grupo) {
        subtitulo += ` - ${this.grupo.etiqueta}`;
      }
      subtitulo += ` - ${this.datosEstadistica.info_cuaderno.evaluacion.nombre}`;

      return subtitulo;
    },
    cargando() {
      return !this.datosEstadistica.alumno;
    },
  },
  mounted() {
    this.cargarChart();
  },
  methods: {
    fullname: usuarios.fullname,
    cargarChart() {
      cuadernoAsistencias.estadisticasAlumno(
        this.cuadernoId, this.alumnoId, this.fecha, this.admin,
      ).then((result) => {
        this.datosEstadistica = result.data;
        const estadistica = this.datosEstadistica.data;
        this.grupo = this.datosEstadistica.grupo;
        this.retrasosTotales = estadistica['retrasos-totales'] || 0;

        delete estadistica['retrasos-totales'];
        delete estadistica.asistencia;
        // Detalle de las privaciones
        delete estadistica.privacion;
        // Sumatorio o nosequé
        delete estadistica.privaciones;

        this.tiposAsistencia = this.tiposValidos.map((key) => (
          { value: key, label: humanEnumName('alumno_asistencia', 'tipo', underscore(key)) }
        ));
        this.$nextTick(() => this.renderChart(estadistica));
      });
    },
    renderChart(estadistica) {
      const labels = this.tiposAsistencia.map((asis) => asis.label);
      const data = this.tiposAsistencia.map((asis) => estadistica[asis.value]);

      // Si cierran el modal antes de cargar los datos ya no existe
      if (!this.$refs.chart) {
        return;
      }
      const ctx = this.$refs.chart.getContext('2d');
      const chart = new Chart(ctx, {
        type: 'bar',
        data: {
          labels,
          datasets: [{
            data,
            // Colores para cada tipo
            backgroundColor: [
              // 'rgba(110, 211, 110, 0.2)',
              'rgba(255, 99, 132, 0.2)',
              'rgba(54, 162, 235, 0.2)',
              'rgba(255, 206, 86, 0.2)',
              'rgba(153, 102, 255, 0.2)',
              'rgba(255, 159, 64, 0.2)',
              'rgba(255, 99, 132, 0.2)',
              'rgba(255, 99, 132, 0.2)',
            ],
            borderColor: [
              // 'rgba(110, 211, 110, 1)',
              'rgba(255, 99, 132, 1)',
              'rgba(54, 162, 235, 1)',
              'rgba(255, 206, 86, 1)',
              'rgba(153, 102, 255, 1)',
              'rgba(255, 159, 64, 1)',
              'rgba(255, 99, 132, 1)',
              'rgba(255, 99, 132, 1)',
            ],
            borderWidth: 1,
          }],
        },
        options: {
          responsive: false,
          legend: {
            display: false,
          },
          hover: {
            animationDuration: 0,
          },
          scales: {
            yAxes: [{
              display: false,
              gridLines: {
                display: false,
              },
              ticks: {
                // 20% de alto para dejar espacio al título de las barras
                max: Math.max.apply(null, data) * 1.20,
                // display: false,
                beginAtZero: true,
              },
            }],
            xAxes: [{
              display: false,
              ticks: {
                autoSkip: false,
              },
            }],
          },
          tooltips: {
            enabled: true,
          },
          animation: {
            duration: Cifra.Conf.ANIMATION_SPEED,
            easing: 'easeInQuad',
            onComplete: function onComplete() {
              // render the value of the chart above the bar
              ctx.font = Chart.helpers.fontString(Chart.defaults.global.defaultFontSize, 'normal', Chart.defaults.global.defaultFontFamily);
              ctx.fillStyle = this.chart.config.options.defaultFontColor;
              ctx.textAlign = 'center';
              ctx.textBaseline = 'bottom';
              this.data.datasets.forEach((dataset) => {
                for (let i = 0; i < dataset.data.length; i += 1) {
                  const model = dataset._meta[Object.keys(dataset._meta)[0]].data[i]._model;
                  ctx.fillText(dataset.data[i], model.x, model.y - 5);
                }
              });
            },
          },
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.chart-icons {
  display: flex;
  margin: 14px 0;

  .icon-box {
    flex-grow: 1;
  }
}
</style>
